import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Layout, FenceConfigurator, Wizualizator, DisclaimerPopup } from './components'
import AdminPanel from './components/AdminPanel'
import IframeTestPage from './components/IframeTestPage'
import { FenceProvider, useFence } from './contexts/FenceContext'

function AppContent() {
  const { state } = useFence()

  return (
    <Layout>
      {state.activeTab === 'konfigurator' ? <FenceConfigurator /> : <Wizualizator />}
      <DisclaimerPopup />
    </Layout>
  )
}

function App() {
  const handleReset = () => {
    // Callback który będzie wywoływany przy resetowaniu projektu
    console.log('🔄 Projekt został zresetowany - scena 3D powinna zostać wyczyszczona')
    
    // 🎯 NOWE: Wyczyść scenę 3D
    if ((window as any).clearAllFenceElements) {
      console.log('🧹 App: Wywołuję clearAllFenceElements')
      ;(window as any).clearAllFenceElements()
    } else {
      console.log('⚠️ App: clearAllFenceElements nie jest dostępne')
    }
  }

  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/iframe-test" element={<IframeTestPage />} />
        <Route path="/*" element={
          <FenceProvider onReset={handleReset}>
            <AppContent />
          </FenceProvider>
        } />
      </Routes>
    </Router>
  )
}

export default App
